import { Vector2 } from 'three/webgpu'
import { easing } from 'maath'
import DeviceControl from './DeviceControl'

export default class DeviceSlider extends DeviceControl {
	static defaults = {
		axis: 'z',
		travel: [-0.3, 0.0],
		smoothing: 0.04,
	}

	static draggable = true

	constructor(options = {}) {
		super(options)

		this.value = 0
		this.target = 0
		this.origin = 0

		this.start = new Vector2()
		this.head = new Vector2()
		this.tail = new Vector2()
		this.direction = new Vector2()
	}

	press(pointer) {
		this.origin = this.target
		this.start.copy(pointer)

		this.project(this.head)
		this.project(this.tail, this.options.axis)
		this.direction.copy(this.tail).sub(this.head)
	}

	drag(pointer) {
		const [min, max] = this.options.travel
		const lengthSq = this.direction.lengthSq()

		if (!lengthSq) return

		const alongX = (pointer.x - this.start.x) * this.direction.x
		const alongY = (pointer.y - this.start.y) * this.direction.y

		this.target = Math.min(max, Math.max(min, this.origin + (alongX + alongY) / lengthSq))
	}

	update(delta) {
		easing.damp(this, 'value', this.target, this.options.smoothing, delta)

		this.position.copy(this.rest)
		this.position[this.options.axis] += this.value
	}
}
